import clsx from 'clsx';
import React from 'react';
import { useI18n } from '../i18n';

type PortalLoaderProps = {
  label?: React.ReactNode;
  variant?: 'screen' | 'content';
  className?: string;
};

const PortalLoader: React.FC<PortalLoaderProps> = ({
  label,
  variant = 'screen',
  className,
}) => {
  const { t } = useI18n();

  return (
    <div
      className={clsx(
        'flex w-full items-center justify-center bg-gray-50 px-6',
        variant === 'screen' ? 'min-h-screen' : 'min-h-[18rem]',
        className,
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="w-full max-w-[240px] text-center">
        <img
          src="/we-dohockey-orange-black-trans.png"
          alt="doHockey"
          className="mx-auto h-12 w-auto"
        />
        <div className="mt-6 h-1 overflow-hidden rounded-full bg-gray-200" aria-hidden="true">
          <span className="portal-loader-progress block h-full w-2/5 rounded-full bg-primary-500" />
        </div>
        <p className="ui-meta mt-3">{label ?? t('loading')}</p>
      </div>
    </div>
  );
};

export default PortalLoader;
